module.exports = __webpack_public_path__ + "static/media/M8.867d0331.jpeg";